<!--component html goes here -->
<!--component html goes here -->
<page-load-header *ngIf="!initialized"></page-load-header>
<ng-container *ngIf="initialized">
  <header>
    <!-- Fixed navbar -->
    <nav class="navbar nowrap navbar-expand-md navbar-light bg-white">
      <a class="navbar-brand text-truncate" [routerLink]="[]">Poster {{ poster.title }}</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <!-- <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled" href="#">Disabled</a>
          </li>
        </ul> -->
        <div class="form-inline ml-auto mt-2 mt-md-0">
          <button type="button" class="btn btn-icon" (click)="exitPage()">
            <h3 class="m-0 text-muted"><i class="fas fa-times"></i></h3>
          </button>
        </div>
      </div>
    </nav>
  </header>

  <main id="poster" class="main-container">
    <div class="main-theater">
      <div class="row no-gutters">
        <div class="col text-center exhibit-container order-12 order-xl-1">
          <lib-ngx-image-zoom [enableLens]="false" [lensWidth]="800" [enableScrollZoom]="true" [scrollStepSize]="0.05" [lensHeight]="400" [thumbImage]="'fetchimage?filename=' + poster.posterAssetPath"></lib-ngx-image-zoom>
        </div>
        <footer class="live-footer">
          <div class="row no-gutters">
            <div class="col pl-2 pr-2">
              <div class="d-flex">
                <div class="mr-auto">
                  <div class="align-middle">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Tech Support">
                        <p class="text-primary"><a type="button" (click)="techSupportClicked()">Tech Support</a></p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div class="align-middle">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item mr-3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Chat">
                        <p class="text-primary"><a [ngClass]="{ 'live-event-link-active': showFeedback }" type="button" (click)="showFeedback = !showFeedback">Feedback</a></p>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- <div>
                  <div class="align-middle">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item mr-3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Chat">
                        <p class="text-primary"><a type="button" target="_blank" href=" ">Website</a></p>
                      </li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="col chat-sidebar pt-1"></div>
          </div>
        </footer>
        <div class="popover-window col" [ngClass]="{ 'd-none': !showFeedback }">
          <poster-feedback [poster]="poster" (closed)="showFeedback = false"></poster-feedback>
        </div>
        <div class="col chat-sidebar order-1 order-xl-12">
          <div class="full-screen-wrapper" #fullScreenContainer>
            <div class="exhibit-video" id="webRTCLayoutContainer" #webRTCLayoutContainer>
              &nbsp;
              <!-- Banner display -->
            </div>
            <div class="bg-dark p-2 d-flex">
              <div class="mr-auto">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button *ngIf="!publishing" type="button" (click)="activateCamera()" class="btn btn-xs btn-success transition-3d-hover"><i class="fas fa-video"></i> Join Video</button>
                    <button *ngIf="publishing" type="button" (click)="unpublish()" class="btn btn-xs btn-danger transition-3d-hover"><i class="fas fa-video-slash"></i> Leave Video</button>
                  </li>
                  <li *ngIf="publishing && publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
                      <span class="fas fa-video"></span>
                    </button>
                  </li>
                  <li *ngIf="publishing && !publishingVideo" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button type="button" (click)="toggleVideo()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
                      <span class="fas fa-video-slash"></span>
                    </button>
                  </li>
                  <li *ngIf="publishing && publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-success transition-3d-hover">
                      <span class="fas fa-microphone"></span>
                    </button>
                  </li>
                  <li *ngIf="publishing && !publishingAudio" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button type="button" (click)="toggleAudio()" class="btn btn-sm btn-icon btn-primary transition-3d-hover">
                      <span class="fas fa-microphone-slash"></span>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="ml-auto">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item device-settings-button" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button (click)="showDeviceSettings()" type="button" class="btn btn-sm btn-icon btn-secondary transition-3d-hover">
                      <span class="fas fa-cog btn-icon__inner"></span>
                    </button>
                  </li>
                  <li class="list-inline-item" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                    <button type="button" (click)="fullscreen()" class="btn btn-icon btn-sm text-white transition-3d-hover">
                      <h3><span class="fas fa-compress-wide btn-icon__inner"></span></h3>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div #messageContainer class="live-messages">
            <ul>
              <li *ngFor="let message of poster.chatHistory" [ngClass]="{ replies: user.id != message.user.id, sent: user.id == message.user.id }">
                <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + message.user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ message.user.id }}-avatar.png"   />
                <span *ngIf="user.id != message.user.id">{{ message.user.firstName + ' ' + message.user.lastName }}</span>
                <p class="message-content" innerHTML="{{ message.message }}"></p>
              </li>
              <li *ngFor="let message of messages" [ngClass]="{ replies: user.id != message.userId, sent: user.id == message.userId }">
                <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + message.userId" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ message.userId }}-avatar.png" /><span *ngIf="user.id != message.userId">{{ message.name }}</span>
                <p class="message-content" innerHTML="{{ message.message }}"></p>
              </li>
            </ul>
            <p *ngIf="messages.length + poster.chatHistory.length == 0" class="no-chats">Say hello.</p>
          </div>
          <div class="bxl-emoji-picker" [style.visibility]="toggled ? 'visible' : 'hidden'">
            <div class="btn-group" role="group" aria-label="First group">
              <button type="button" (click)="handleSelection('😀')" class="btn btn-lg xs-no-padding btn-white">😀</button>
              <button type="button" (click)="handleSelection('😂')" class="btn btn-lg xs-no-padding btn-white">😂</button>
              <button type="button" (click)="handleSelection('😲')" class="btn btn-lg xs-no-padding btn-white">😲</button>
              <button type="button" (click)="handleSelection('😞')" class="btn btn-lg xs-no-padding btn-white">😞</button>
              <button type="button" (click)="handleSelection('👍')" class="btn btn-lg xs-no-padding btn-white">👍</button>
              <button type="button" (click)="handleSelection('👎')" class="btn btn-lg xs-no-padding btn-white">👎</button>
              <button type="button" (click)="handleSelection('❤️')" class="btn btn-lg xs-no-padding btn-white">❤️</button>
              <button type="button" (click)="handleSelection('❗️')" class="btn btn-lg xs-no-padding btn-white">❗️</button>
              <button type="button" (click)="handleSelection('❓')" class="btn btn-lg xs-no-padding btn-white">❓</button>
            </div>
          </div>
          <div class="input-group" style="margin-bottom: 5px">
            <input #chatbox type="text" class="form-control" [(ngModel)]="chatMessage" (keyup.enter)="sendMessage()" placeholder="Type a message..." aria-label="" aria-describedby="button-addon2" />
            <div class="input-group-append">
              <button class="btn btn-white" (click)="toggled = !toggled" type="button" id="button-addon2">😄</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- <footer class="live-footer">
    <div class="container-fluid">
      <p>hello</p>
    </div>

  </footer> -->
</ng-container>
